import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function HttpLoaderFactory(http: HttpClient) {
  const assets = (window as any).ASSETS_URL;
  const prefix = assets ? assets + 'i18n/' : undefined;

  return new TranslateHttpLoader(http, prefix);
}
